const IGNORED_DOMAINS = [];

function processLink(link) {
  if (link.dataset.externalProcessed === 'true') return;

  const href = link.getAttribute('href');
  if (!href) return;

  try {
    const url = new URL(href, window.location.href);
    
    // If the link is internal (same origin), skip processing.
    if (url.origin === window.location.origin) {
      link.dataset.externalProcessed = 'true';
      return;
    }
    
    const hostname = url.hostname;
    const isIgnored = IGNORED_DOMAINS.some(domain => hostname.includes(domain));
    
    if (!isIgnored) {
      link.setAttribute('target', '_blank');
    }
  } catch (error) {
    console.error('Invalid URL:', href, error);
  }

  link.dataset.externalProcessed = 'true';
}

function processLinks(root = document) {
  const links = root.querySelectorAll('a');
  links.forEach(link => processLink(link));
}

document.addEventListener('DOMContentLoaded', () => {
  processLinks();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName && node.tagName.toLowerCase() === 'a') {
            processLink(node);
          }
          processLinks(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
